__turbopack_context__.v({
  "className": "s6w51G_className",
});
